import { render, staticRenderFns } from "./BtnSolid.vue?vue&type=template&id=5d44a0e6&scoped=true&"
import script from "./BtnSolid.vue?vue&type=script&lang=js&"
export * from "./BtnSolid.vue?vue&type=script&lang=js&"
import style0 from "./BtnSolid.vue?vue&type=style&index=0&id=5d44a0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44a0e6",
  null
  
)

export default component.exports